import React, { useState, useEffect } from "react";
import { Container, Row, Col, Spinner } from "reactstrap";
import { FaCheckCircle, FaSpinner } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { LuLoader2 } from "react-icons/lu";
import  parse  from "react-html-parser";

const LoaderBoxSteps = ({ steps ,currentStep}) => {


  return (
    <Container className="mt-2">
      <Row>
        <Col>
        {
         steps && steps.map((step)=>{

            return  <div className="step">
            <Step
              stepNumber={step.stepNumber}
              isCurrent={currentStep === step.stepNumber}
              isCompleted={currentStep > step.stepNumber}
              stepText={<div> {step.stepText} </div> }
            />
          </div>
          })
        }
         
     
        </Col>
      </Row>
    </Container>
  );
};

const Step = ({ stepNumber, isCurrent, isCompleted, stepText }) => (
  <div className="d-flex align-items-center mb-3">
    <Row>
      <Col md={1} xs={1}>
        {isCurrent && !isCompleted && <span className="trivvy-loader"></span>}
        {isCompleted && <FaCheck className="text-success" />}
      </Col>
      <Col md={9} xs={9}>
        <span >{stepText}</span>
      </Col>
    </Row>
  </div>
);

export default LoaderBoxSteps;
